import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { getallcustomers } from "../../../actions/getclients";

function DeleteModal({ closemodal, customerData }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  function handleDelete() {
    if (document.getElementById("userEmail").value === "") {
      toast.info("Email is required");
    } else if (document.getElementById("userPassword").value === "") {
      toast.info("Password is required");
    } else {
      setLoading(true);

      const CustomerCnic = customerData?.CustomerCnic;
      const Email = document.getElementById("userEmail").value;
      const Password = document.getElementById("userPassword").value;

      axios({
        url: `${process.env.REACT_APP_API_URL}Customers/Delete?CustomerCnic=${CustomerCnic}&Email=${Email}&Password=${Password}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "content-type": "application/json",
        },
      }).then(
        (result) => {
          setLoading(false);
          if (result.data.IsSuccess === true) {
            toast.info(result.data.Message);
            document.getElementById("userEmail").value = "";
            document.getElementById("userPassword").value = "";
            dispatch(getallcustomers());
            closemodal();
          } else {
            toast.info(result.data.Message);
          }
        },
        () => {
          setLoading(false);
          toast.info("Something went wrong!");
        }
      );
    }
  }
  return (
    <div id="customerDeleteModal" class="modal">
      <div class="modal-add-seller">
        <div className="row">
          <div className="col-12  page_heading">
            <h4 className="  text-center pt-2">Delete Customer</h4>
            <span
              class="close pr-2  "
              onClick={() => {
                document.getElementById("userEmail").value = "";
                document.getElementById("userPassword").value = "";
                closemodal();
              }}
            >
              &times;
            </span>
          </div>
        </div>

        <div class="modal-body">
          <p className="font-weight-bold">
            Please enter Email and Password to delete "
            {customerData?.CustomerName}"
          </p>
          <div className="row mt-2">
            <div className="col-2 text-left p-0">
              <label className="input_label m-0 ">Email :</label>
            </div>
            <div className="col-10  p-0">
              <input
                type="email"
                className="input_styling ml-md-3"
                id="userEmail"
                autoComplete="off"
                readOnly
                onMouseDown={(e) => {
                  e.target.removeAttribute("readOnly");
                }}
              />
              <span className="estaric">*</span>
            </div>

            <div className="col-2 text-left p-0 mt-4">
              <label className="input_label m-0 ">Password :</label>
            </div>
            <div className="col-10 p-0 mt-4">
              <input
                type="password"
                className="input_styling ml-md-3"
                id="userPassword"
                autoComplete="off"
                readOnly
                onMouseDown={(e) => {
                  e.target.removeAttribute("readOnly");
                }}
              />
              <span className="estaric">*</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          {loading && (
            <Loader
              type="Oval"
              color="black"
              height={30}
              width={30}
              radius={12}
            />
          )}
          <button
            className="cancel_btn  ml-2"
            id="creditorsave"
            disabled={loading}
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;
DeleteModal.propTypes = {
  closemodal: PropTypes.func,
  customerData: PropTypes.any,
};
